/* Delivery type of an offer */
export enum DeliveryType {
	NachAufwand = 0,
	Post = 1,
	LKW = 2,
	Kurier = 3,
}
